'use client';

import Icon from '@egalite/ui/Icon';
import BottomSection from '@egalite/ui/IncluiPCD/JobSearch/BottomSection';
import TopSection from '@egalite/ui/IncluiPCD/JobSearch/TopSection';
import { FC } from 'react';

const workPlaceTypeOptions = [
	{
		value: 'Trabalho Remoto Permanente',
		label: '100% remoto',
	},
	{
		value: 'Presencial',
		label: '100% na empresa',
	},
	{
		value: 'Híbrido',
		label: 'Trabalho híbrido',
	},
];

const educationOptions = [
	{
		value: 'Ens. Fund. Incompleto',
		label: 'Ens. Fund. Incompleto',
	},
	{
		value: 'Ens. Fund. Completo',
		label: 'Ens. Fund. Completo',
	},
	{
		value: 'Ens. Médio Incompleto',
		label: 'Ens. Médio Incompleto',
	},
	{
		value: 'Ens. Médio Completo',
		label: 'Ens. Médio Completo',
	},
	{
		value: 'Ens. Técnico Incompleto',
		label: 'Ens. Técnico Incompleto',
	},
	{
		value: 'Ens. Técnico Completo',
		label: 'Ens. Técnico Completo',
	},
	{
		value: 'Ens. Superior Incompleto',
		label: 'Ens. Superior Incompleto',
	},
	{
		value: 'Ens. Superior Completo',
		label: 'Ens. Superior Completo',
	},
	{
		value: 'Pós-Graduação Incompleta',
		label: 'Pós-Graduação Incompleta',
	},
	{
		value: 'Pós-Graduação Completa',
		label: 'Pós-Graduação Completa',
	},
	{
		value: 'Mestrado Incompleto',
		label: 'Mestrado Incompleto',
	},
	{
		value: 'Mestrado Completo',
		label: 'Mestrado Completo',
	},
	{
		value: 'Doutorado Incompleto',
		label: 'Doutorado Incompleto',
	},
	{
		value: 'Doutorado Completo',
		label: 'Doutorado Completo',
	},
];

const sectorsOptions = [
	{
		value: 'Recursos Humanos',
		label: 'Recursos Humanos',
	},
	{
		value: 'Almoxarifado',
		label: 'Almoxarifado',
	},
	{
		value: 'Financeiro',
		label: 'Financeiro',
	},
	{
		value: 'Saúde',
		label: 'Saúde',
	},
	{
		value: 'Produção',
		label: 'Produção',
	},
	{
		value: 'Comercial',
		label: 'Comercial',
	},
	{
		value: 'Educação',
		label: 'Educação',
	},
	{
		value: 'Indústria',
		label: 'Indústria',
	},
	{
		value: 'Qualidade',
		label: 'Qualidade',
	},
	{
		value: 'Segurança do trabalho',
		label: 'Segurança do trabalho',
	},
	{
		value: 'Administrativo',
		label: 'Administrativo',
	},
	{
		value: 'Call center',
		label: 'Call center',
	},
	{
		value: 'Serviços gerais',
		label: 'Serviços gerais',
	},
	{
		value: 'Atendimento',
		label: 'Atendimento',
	},
	{
		value: 'Logística',
		label: 'Logística',
	},
	{
		value: 'Alimentação',
		label: 'Alimentação',
	},
	{
		value: 'Auditoria',
		label: 'Auditoria',
	},
	{
		value: 'Compliance',
		label: 'Compliance',
	},
	{
		value: 'Compras',
		label: 'Compras',
	},
	{
		value: 'Construção',
		label: 'Construção',
	},
	{
		value: 'Elétrica/eletrônica',
		label: 'Elétrica/eletrônica',
	},
	{
		value: 'Engenharia',
		label: 'Engenharia',
	},
	{
		value: 'Fiscal',
		label: 'Fiscal',
	},
	{
		value: 'Jurídico',
		label: 'Jurídico',
	},
	{
		value: 'Manutenção',
		label: 'Manutenção',
	},
	{
		value: 'Marketing',
		label: 'Marketing',
	},
	{
		value: 'Outro',
		label: 'Outro',
	},
	{
		value: 'Portaria/Segurança',
		label: 'Portaria/Segurança',
	},
	{
		value: 'Tecnologia (TI)',
		label: 'Tecnologia (TI)',
	},
];

const SearchFallback: FC = () => {
	return (
		<div className="relative">
			<div className="absolute inset-0 flex items-center justify-center bg-white/60">
				<Icon name="circle-dashed" className="text-5xl text-brand-main animate-spin" />
			</div>

			<TopSection
				cities={[{ value: 'São Paulo', label: 'São Paulo' }]}
				states={[{ value: 'São Paulo', label: 'São Paulo' }]}
				locationDisabled={false}
				search={''}
				selectedCity={''}
				selectedState={''}
				onSearch={() => {}}
				setSearch={() => {}}
				setSelectedCity={() => {}}
				setSelectedState={() => {}}
				onFilterButtonPress={() => {}}
			/>

			<BottomSection
				jobs={null}
				workPlaceOptions={workPlaceTypeOptions}
				educationOptions={educationOptions}
				sectorOptions={sectorsOptions}
				filterOpen={false}
				educations={[]}
				sectors={[]}
				workPlaces={[]}
				sponsors={[]}
				supporters={[]}
				setFilterOpen={() => {}}
				page={1}
				pageMax={999}
				onNextPage={() => {}}
				onPreviousPage={() => {}}
				setEducations={() => {}}
				setSectors={() => {}}
				setWorkPlaces={() => {}}
				setSponsors={() => {}}
				setSupporters={() => {}}
			/>
		</div>
	);
};

export default SearchFallback;
